import React, { useState } from "react";

export const Scenario1 = ({ data }) => {
  const [modalImage, setModalImage] = useState(null); // Estado para manejar la imagen en el modal

  const handleImageClick = (imageSrc) => {
    setModalImage(imageSrc);
  };

  const closeModal = () => {
    setModalImage(null);
  };

  return (
    <div id="about" className="container">
      {/* FILA PARA IMÁGENES */}
      <div className="row" style={{ display: "flex", justifyContent: "center", margin: "0" }}>
        <div className="col-md-6 col-xs-12 text-center">
          <img
            src="img/escenario1-map.png"
            className="img-responsive"
            alt="Scenario 2 - Map"
            style={{
              cursor: "pointer",
              borderRadius: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
              transition: "transform 0.3s ease-in-out",
              maxWidth: "100%",
              height: "auto",
            }}
            onClick={() => handleImageClick("img/escenario1-map.png")}
            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
          />
        </div>
        <div className="col-md-6 col-xs-12 text-center">
          <img
            src="img/escenario1-flow.jpg"
            className="img-responsive"
            alt="Scenario 2 - Flow"
            style={{
              cursor: "pointer",
              borderRadius: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
              transition: "transform 0.3s ease-in-out",
              maxWidth: "100%",
              height: "auto",
            }}
            onClick={() => handleImageClick("img/escenario1-flow.jpg")}
            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
          />
        </div>
      </div>

      {/* FILA PARA TEXTO */}
      <div className="row" style={{ marginTop: "100px"}}>
        <div className="col-md-12 text-center">
          <h2 style={{ fontSize: "28px", fontWeight: "bold", marginBottom: "20px" }}>
            {data?.title || "Loading..."}
          </h2>
          <p style={{ fontSize: "18px", lineHeight: "1.6", padding: "0 10px" }}>
            {data?.paragraph || "Loading..."}
          </p>
          <p style={{ fontSize: "18px", lineHeight: "1.6", padding: "0 10px" }}>
            {data?.paragraphB || "Loading..."}
          </p>
        </div>
      </div>

      {/* MODAL PARA IMAGEN AMPLIADA */}
      {modalImage && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={closeModal}
        >
          <img
            src={modalImage}
            alt="Enlarged"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "10px",
              boxShadow: "0px 6px 15px rgba(255, 255, 255, 0.3)",
            }}
          />
        </div>
      )}
    </div>
  );
};
